import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("label", { for: "inputFile" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-upload" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", { class: _ctx.getVisibility }, [
    _createVNode("span", { "v-if": _ctx.label }, _toDisplayString(_ctx.label), 9, ["v-if"]),
    _createVNode("input", {
      ref: "inputFile",
      id: _ctx.id,
      type: "file",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeFunction && _ctx.changeFunction(...args))),
      accept: _ctx.accept
    }, null, 40, ["id", "accept"]),
    _hoisted_1
  ], 2))
}